import React from "react";
import "./edit-profile-business.scss";
import FooterV2 from "../../components/FooterV2/FooterV2";
import {
  editProfileBusiness,
  editProfileBusinessGst,
} from "../../components/helpers/constant-words";
import { Link } from "react-router-dom";
import { useWindowSize } from "react-use";
import EditGstBusiness from "./EditBusinessProfileComponents/EditGstBusiness";
import { useState } from "react";
import BussinessGst from "./EditBusinessProfileComponents/BussinessGst";

const EditProfileBusinessGST = () => {
  const { width } = useWindowSize();
  const [isGstEdit, setIsGstEdit] = useState(true);
  return (
    <>
      <main className="edit_container-business edit_container-business-mob">
        <section className="edit_sec1">
          <div className="my_container">
            <div className="row">
              {/* <div className="col-md-3 d-none d-md-block d-lg-block"> */}
              <div className="col-md-3 d-md-block d-lg-block">
                <p className="title">My Account</p>
                <ul className="account_list">
                  <li className="list-item">
                    <Link to={editProfileBusiness}>Edit Your Profile</Link>
                  </li>
                  <li className="list-item">Edit GST</li>
                </ul>
              </div>
              <div className="col-md-9">
                <div className="role_wrap">
                  <p className="role_title">EDIT GST</p>
                </div>
                <div className="profile_form_container">
                  <div className={`row ${width < 600 && "gx-0"}`}>
                    <div className={`col-lg-6 ${width > 992 && "ps-0"}`}>
                      {isGstEdit ? (
                        <EditGstBusiness lightTheme={true} />
                      ) : (
                        <BussinessGst lightTheme={true} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterV2 lightTheme />
      </main>
    </>
  );
};

export default EditProfileBusinessGST;
